import { render } from "./SuggestArticle.vue?vue&type=template&id=39ab3712&scoped=true"
import script from "./SuggestArticle.vue?vue&type=script&lang=js"
export * from "./SuggestArticle.vue?vue&type=script&lang=js"

import "./SuggestArticle.vue?vue&type=style&index=0&id=39ab3712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ab3712"]])

export default __exports__